import { RequestDemoForm } from "@/components/forms";
import Button from "@/components/ui/button";
import { SectionLayout } from "layouts";
import { Trans } from "react-i18next";
import { form } from "../../forms/styles/get-in-touch";

const HowMhealthStudioWorks = () => {
  return (
    <SectionLayout
      separatorProps={{
        variant: "offset",
      }}
      heading={
        <Trans i18nKey="mhealth.how-mhealth-studio-works.heading">
          How mhealth studio <strong>works</strong>
        </Trans>
      }
    >
      <div className="grid gap-4 md:grid-cols-1">
        {/* <div className="grid bg-grey place-items-center aspect-video">
          video player
        </div> */}
        <div className="flex flex-col justify-center gap-4 mx-auto">
          <div className="grid text-[25px]">
            <h3 className="mx-auto font-bold uppercase">
              <Trans i18nKey="mhealth.how-mhealth-studio-works.book-a-free-live-demo.heading">
                Book a free live demo
              </Trans>
            </h3>
            <p className="mx-auto font-thin">
              <Trans i18nKey="mhealth.how-mhealth-studio-works.book-a-free-live-demo.body">
                Let us show you how mHealth Studio can boost your clinic.
              </Trans>
            </p>
          </div>
          <RequestDemoForm
            formId="mhealth-studio-request-demo-form"
            bookButtonOnly
            bookButtonClassNames="min-w-[257px] font-light"
            bookButtonText={
              <Trans i18nKey="mhealth-studio.how-mhealth-studio-works.book-a-free-live-demo.button">
                Book Now
              </Trans>
            }
            translationPrefix="mhealth"
            themeColor={{
              color: "text-[#04A9F4]",
              backgroundColor: "bg-[#04A9F4]",
            }}
          />
        </div>
      </div>
    </SectionLayout>
  );
};

export default HowMhealthStudioWorks;
